import { c as _c } from "react/compiler-runtime";
import type { DocumentUploadSettings } from '@onefootprint/request-types/dashboard';
import { CodeInline } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import Item from '@/playbook-builder/components/item';
import Section from '@/playbook-builder/components/section';
import type { CollectDocumentNodeProps } from '@/playbook-builder/playbook-builder.types';
type BusinessViewProps = {
  node: CollectDocumentNodeProps;
};
const BusinessView = t0 => {
  const $ = _c(18);
  const {
    node
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectDocument.additionalDocuments"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let T0;
  let t2;
  let t3;
  let t4;
  if ($[1] !== node.data.documents || $[2] !== t) {
    const customDocuments = node.data.documents.filter(_temp);
    let t5;
    if ($[7] !== t) {
      t5 = uploadSettings => {
        if (uploadSettings === "prefer_upload") {
          return t(_temp2);
        }
        if (uploadSettings === "capture_only_on_mobile") {
          return t(_temp3);
        }
        return t(_temp4);
      };
      $[7] = t;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    const renderUploadSettings = t5;
    T0 = Section;
    if ($[9] !== t) {
      t4 = t(_temp5);
      $[9] = t;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t2 = "flex flex-col gap-4";
    t3 = customDocuments.length > 0 ? customDocuments.map(t6 => {
      const {
        data
      } = t6;
      return <div key={data.identifier} className="flex flex-col gap-4 not-first:border-t not-first:border-dashed not-first:border-primary not-first:pt-4"><Item label={t(_temp6)} value={<div className="text-body-2">{data.name}</div>} /><Item label={t(_temp7)} value={<CodeInline size="compact">{data.identifier}</CodeInline>} /><Item label={t(_temp8)} value={<div className="text-body-2">{renderUploadSettings(data.uploadSettings)}</div>} /></div>;
    }) : <p className="text-body-2 text-tertiary">{t(_temp9)}</p>;
    $[1] = node.data.documents;
    $[2] = t;
    $[3] = T0;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    T0 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t3) {
    t5 = <div className={t2}>{t3}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== T0 || $[15] !== t4 || $[16] !== t5) {
    t6 = <T0 title={t4}>{t5}</T0>;
    $[14] = T0;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export default BusinessView;
function _temp(doc) {
  return doc.kind === "custom";
}
function _temp2($) {
  return $.custom.upload;
}
function _temp3($_0) {
  return $_0.custom.captureOnlyMobile;
}
function _temp4($_1) {
  return $_1.custom.capture;
}
function _temp5($_2) {
  return $_2.custom.title;
}
function _temp6($_3) {
  return $_3.custom.documentLabel;
}
function _temp7($_4) {
  return $_4.custom.identifier;
}
function _temp8($_5) {
  return $_5.custom.preferredMethod;
}
function _temp9($_6) {
  return $_6.custom.emptyState;
}